import { render } from "./ReceiptView.vue?vue&type=template&id=d1cf0452"
import script from "./ReceiptView.vue?vue&type=script&lang=js"
export * from "./ReceiptView.vue?vue&type=script&lang=js"

import "./ReceiptView.vue?vue&type=style&index=0&id=d1cf0452&lang=css"

import exportComponent from "/Users/avinduhewa/Documents/Projects/bokaklip/payl-firebase/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__